var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as crypto from '../crypto';
import * as utils from 'keystore-idb/utils';
import { didToPublicKey } from './transformers';
import { KeyType } from './types';
/**
 * Verify the signature of some data (string, ArrayBuffer or Uint8Array), given a DID.
 */
export function verifySignedData(_a) {
    var _b = _a.charSize, charSize = _b === void 0 ? 16 : _b, data = _a.data, did = _a.did, signature = _a.signature;
    return __awaiter(this, void 0, void 0, function () {
        var _c, type, publicKey, sigBytes, dataBytes, keyBytes, _d, _1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 7, , 8]);
                    _c = didToPublicKey(did), type = _c.type, publicKey = _c.publicKey;
                    sigBytes = new Uint8Array(utils.base64ToArrBuf(signature));
                    dataBytes = new Uint8Array(utils.normalizeUnicodeToBuf(data, charSize));
                    keyBytes = new Uint8Array(utils.base64ToArrBuf(publicKey));
                    _d = type;
                    switch (_d) {
                        case KeyType.Edwards: return [3 /*break*/, 1];
                        case KeyType.RSA: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, crypto.ed25519.verify(dataBytes, sigBytes, keyBytes)];
                case 2: return [2 /*return*/, _e.sent()];
                case 3: return [4 /*yield*/, crypto.rsa.verify(dataBytes, sigBytes, keyBytes)];
                case 4: return [2 /*return*/, _e.sent()];
                case 5: return [2 /*return*/, false];
                case 6: return [3 /*break*/, 8];
                case 7:
                    _1 = _e.sent();
                    return [2 /*return*/, false];
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=validation.js.map